import { useSelector } from 'react-redux';
import ConfirmationModal from './common/modals/ConfirmationModal';
import ResolutionModal from './common/modals/ResolutionModal';

const ConflictNotes = () => {
  const isOpenConflictConfirmation = useSelector(
    state => state.account?.isOpenConflictConfirmation
  );
  const isOpenConflictResolution = useSelector(
    state => state.account?.isOpenConflictResolution
  );

  return (
    <>
      {isOpenConflictConfirmation && <ConfirmationModal />}
      {isOpenConflictResolution && <ResolutionModal />}
    </>
  );
};

export default ConflictNotes;
